import * as React from 'react';
import * as PropTypes from 'prop-types';
import IconWrapper from './IconWrapper';

const IconFiletypePdf = props =>
  React.createElement(
    IconWrapper,
    props,
    <svg
      viewBox="0 0 60 60"
      xmlns="http://www.w3.org/2000/svg"
      className="block w-full h-full fill-current"
    >
      <style>{'.filetype-pdf_svg__st0{fill:#fff}.filetype-pdf_svg__st1{fill:#434a54}'}</style>
      <linearGradient
        id="filetype-pdf_svg__SVGID_1_"
        x1={-1275}
        x2={-1274.3}
        y1={75}
        y2={75.707}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DEDFE3" offset={0} />
        <stop stopColor="#DADBDF" offset={0.178} />
        <stop stopColor="#CECFD3" offset={0.361} />
        <stop stopColor="#B9BCBF" offset={0.546} />
        <stop stopColor="#9CA0A2" offset={0.732} />
        <stop stopColor="#787D7E" offset={0.918} />
        <stop stopColor="#656B6C" offset={1} />
      </linearGradient>
      <path
        className="filetype-pdf_svg__st0"
        d="M52.939 17.773v33.125a3.33 3.33 0 01-3.32 3.32H18.505a3.33 3.33 0 01-3.32-3.32V40.566h26.288c.977 0 1.797-.8 1.797-1.797V25.84c0-.995-.8-1.796-1.797-1.796H15.185V9.102a3.33 3.33 0 013.32-3.32h22.442v9.96a2.03 2.03 0 002.03 2.031z"
        fill="#fff"
      />
      <path
        className="filetype-pdf_svg__st1"
        d="M49.618 55H18.506a4.101 4.101 0 01-4.102-4.102V40.566c0-.43.352-.781.781-.781h26.289c.547 0 1.016-.45 1.016-1.016V25.84c0-.546-.45-1.015-1.016-1.015H15.185a.784.784 0 01-.781-.781V9.102A4.101 4.101 0 0118.506 5h22.44c.43 0 .782.352.782.781v9.961c0 .684.566 1.25 1.25 1.25h9.96c.43 0 .782.352.782.781v33.125a4.101 4.101 0 01-4.102 4.101zM15.966 41.366v9.53a2.534 2.534 0 002.54 2.54h31.112a2.534 2.534 0 002.54-2.54V18.556h-9.18a2.813 2.813 0 01-2.813-2.813v-9.18h-21.66a2.534 2.534 0 00-2.539 2.54V23.3h25.508a2.576 2.576 0 012.578 2.578v12.91a2.576 2.576 0 01-2.578 2.578z"
        fill="#434a54"
      />
      <path
        d="M43.27 25.86v12.929c0 .996-.8 1.797-1.796 1.797H8.838c-.996 0-1.797-.801-1.797-1.797v-12.93c0-.996.8-1.797 1.797-1.797h32.636c.996.02 1.797.82 1.797 1.797z"
        fill="#fc0f1a"
      />
      <path
        className="filetype-pdf_svg__st1"
        d="M41.474 41.367H8.838a2.576 2.576 0 01-2.578-2.578v-12.93a2.576 2.576 0 012.578-2.578h32.636a2.576 2.576 0 012.578 2.578v12.93a2.576 2.576 0 01-2.578 2.578zM8.838 24.863c-.547 0-1.016.45-1.016 1.016v12.91c0 .566.45 1.015 1.016 1.015h32.636c.547 0 1.016-.449 1.016-1.015v-12.93c0-.547-.45-1.015-1.016-1.015H8.838z"
        fill="#434a54"
      />
      <path d="M52.939 17.773h-9.961a2.03 2.03 0 01-2.031-2.03V5.78z" fill="#e8e8e8" />
      <path
        className="filetype-pdf_svg__st1"
        d="M52.939 18.555h-9.961a2.813 2.813 0 01-2.813-2.813v-9.96a.786.786 0 011.348-.548l11.953 11.953a.744.744 0 01.273.606.81.81 0 01-.8.762zM41.728 7.675v8.067c0 .684.566 1.25 1.25 1.25h8.086z"
        fill="#434a54"
      />
      <path
        className="filetype-pdf_svg__st0"
        d="M12.822 37.324c-.605 0-1.094-.469-1.094-1.016s.489-.996 1.094-.996c.586 0 1.074.45 1.074.996s-.488 1.016-1.074 1.016zM17.88 34.082v2.383c0 .449-.41.859-.917.859-.489 0-.918-.39-.918-.86v-7.5c0-.507.468-.937 1.015-.937h1.914c2.442 0 3.32 1.465 3.32 3.047 0 1.934-1.308 3.008-3.32 3.008zm0-1.64h1.114c.976 0 1.504-.43 1.504-1.368 0-.684-.274-1.387-1.504-1.387H17.88zM26.61 37.207h-1.464c-.547 0-1.016-.43-1.016-.938v-7.324c0-.508.47-.937 1.016-.937h1.465c2.95 0 3.965 1.62 3.965 3.418v2.246c0 1.855-.996 3.535-3.965 3.535zm2.15-5.762c0-.996-.509-1.777-1.915-1.777h-.879v5.879h.88c1.425 0 1.913-.84 1.913-1.875zM34.345 36.504c0 .449-.41.84-.918.84s-.918-.391-.918-.84v-7.559c0-.45.43-.918.996-.918h3.535c.489 0 .918.39.918.84 0 .469-.41.8-.918.8h-2.714v2.11h2.46c.45 0 .899.352.899.82s-.39.84-.898.84h-2.461v3.067z"
        fill="#fff"
      />
    </svg>,
  );
IconFiletypePdf.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};
export default IconFiletypePdf;
